import { api } from "../../apiProvider";
import { GetDataSetFilterByIdService } from "./getDataSetFilterById.service";
import { mapToLayerItems, mapToFilterCondition } from "../../../filter/mapper";

export const getDataSetFilterByIdAdapter: GetDataSetFilterByIdService = async (params) => {
    const resp = await api.getDataSetFilterById(params.id, params.validFrom, params.slots);
    return { item: mapToLayerItems(resp.data.dataSetFilterDefinition), condition: mapToFilterCondition(resp.data) };
};
